module.exports = __webpack_public_path__ + "80935f5a68ea0905d056ffe441eefb16.svg";